// Generate "Tavo Esmė" - a 3-4 sentence summary about the person

export function generateEssence(lifePath, expression, soul, personality) {
  const essenceMap = {
    // Life Path dominance patterns
    1: "Esate gimęs lyderis su stipria valia ir nepriklausoma dvasia.",
    2: "Jūsų širdis linkusi į harmoniją, bendradarbiavimą ir tarpasmeninį supratimą.",
    3: "Kūrybiškumas ir bendravimas yra jūsų gyvenimo esmė.",
    4: "Stabilumas, ištikimybė ir praktinis požiūris formuoja jūsų charakterį.",
    5: "Laisvė, nuotykiai ir dinamiškumas yra jūsų gyvenimo varomoji jėga.",
    6: "Rūpestis, harmonija ir atsakomybė kitiems apibrėžia jūsų esmę.",
    7: "Išmintis, dvasingumas ir giluminių tiesų paieška kelia jus.",
    8: "Valdžia, sėkmė ir gebėjimas materializuoti vizijas yra jūsų stiprybė.",
    9: "Humanizmas, užuojauta ir troškimas tarnauti didesniam gėriui.",
    11: "Esate šviesos nešėjas su giliu dvasiniu ryšiu ir intuityviu supratimu.",
    22: "Jūs turite galingą gebėjimą materializuoti dideles vizijas ir keisti pasaulį.",
    33: "Mokytojo mokytojas - jūsų misija mokyti per besąlygišką meilę.",
    44: "Vizionierius manifestatorius, galintis kurti sistemines transformacijas."
  };
  
  const soulInsights = {
    1: "vidinė ugnis ir troškimas būti nepriklausomam",
    2: "gilūs emociniai ryšiai ir harmonijos poreikis",
    3: "kūrybinė raiška ir džiaugsmo dalijimasis",
    4: "stabilumo ir saugumo ilgesys",
    5: "laisvės troškimas ir naujų patirčių alkis",
    6: "rūpestis artimaisiais ir harmonijos kūrimas",
    7: "dvasinės išminties ir prasmės paieška",
    8: "valdžios ir materialinės sėkmės troškimas",
    9: "universali meilė ir altruistinis troškimas padėti",
    11: "dvasinis švietimas ir intuityvi įžvalga",
    22: "vizijos materializavimas ir sisteminiai pokyčiai",
    33: "besąlygiška meilė ir mokymo misija",
    44: "globalinė transformacija ir revoliucinės idėjos"
  };
  
  const expressionQualities = {
    1: "Pasaulis mato jus kaip drąsų lyderį ir novatorių.",
    2: "Kiti jus vertina už diplomatiją ir gebėjimą sukurti taiką.",
    3: "Žmonės traukiami jūsų žavesio, kūrybiškumo ir optimizmo.",
    4: "Jus gerbia už patikimumą, darbštumą ir praktiškumą.",
    5: "Jūsų dinaminė energija ir lankstumas įkvepia aplinkinius.",
    6: "Pasaulis jus mato kaip rūpestingą globėją ir harmonijos kūrėją.",
    7: "Kiti jus vertina už išmintį, gilumą ir analitinį protą.",
    8: "Žmonės pripažįsta jūsų autoritetą, galią ir gebėjimą pasiekti sėkmės.",
    9: "Pasaulis mato jus kaip humanistą ir idealią sielą.",
    11: "Kiti jaučia jūsų dvasinę energiją ir įkvėpiančią viziją.",
    22: "Žmonės pripažįsta jūsų gebėjimą kurti didžius dalykus.",
    33: "Pasaulis mato jus kaip mokytoją ir besąlygišką gydytoją.",
    44: "Kiti atpažįsta jūsų kūrybišką ateities matymą ir transformacinę galią."
  };
  
  const personalityNotes = {
    1: "Jūsų išorinis įvaizdas yra stiprus, užtikrintas ir nepriklausomas.",
    2: "Spinduliuojate švelnumą, šiltumą ir prieinamumą.",
    3: "Spinduliuojate džiaugsmą, žaismingumą ir socialinę energiją.",
    4: "Jūsų išorė yra rimta, organizuota ir patikima.",
    5: "Skleidžiate energingą, nuotykių kupinę ir laisvą vibraciją.",
    6: "Atrodote švelnūs, rūpestingi ir šeimos orientuoti.",
    7: "Jūsų išvaizda yra paslaptinga, uždara ir mąstytojo.",
    8: "Spinduliuojate autoritetą, galią ir profesionalumą.",
    9: "Jūsų aura yra užjaučianti, atvira ir pasaulinė.",
    11: "Skleidžiate šviesą, jautrumą ir dvasinę energiją.",
    22: "Jūsų buvimas yra galingas, įtakingas ir įkvepiantis.",
    33: "Spinduliuojate meilę, išmintį ir mokytojo energiją.",
    44: "Jūsų aura yra idėjų kūrėjo, stipri ir transformuojanti."
  };
  
  let essence = essenceMap[lifePath] || essenceMap[1];
  essence += " " + (soulInsights[soul] ? `Jūsų sielos gelmėse - ${soulInsights[soul]}.` : "");
  essence += " " + (expressionQualities[expression] || "");
  
  // Add a fourth sentence if personality differs significantly
  if (personality !== lifePath && personality !== expression) {
    essence += " " + (personalityNotes[personality] || "");
  }
  
  return essence;
}
